import { DesktopSidebarButton } from "./desktop-sidebar-button";

export const DesktopSidebarButtons = () => {
  const sidebarItems = [
    {
      text: "Dashboard",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z"
            fill="currentColor"
          
          />
        </svg>
      ),
      route: "/",
    },
    {
      text: "Applied Posts",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 16H11V11H16V2H2V16ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V12L12 18H2ZM4 11V9H9V11H4ZM4 7V5H14V7H4Z"
            fill="currentColor"

          />
        </svg>
      ),
      route: "/applied-posts",
    },
    {
      text: "Books",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 12H12V10H8V12ZM8 9H16V7H8V9ZM8 6H16V4H8V6ZM6 16C5.45 16 4.97917 15.8042 4.5875 15.4125C4.19583 15.0208 4 14.55 4 14V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H6ZM6 14H18V2H6V14ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4H2V18H16V20H2Z"
            fill="currentColor"

          />
        </svg>
      ),
      route: "/books",
    },
    {
      text: "Video Tutorial",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-video"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>
      ),
      route: "/tutorial",
    },
    {
      text: "Practice Test",
      icon: (
        <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" fill="currentColor"/></svg>
      ),
      route: "/mocktest",
    },
    {
      text: "Settings",
      icon: (
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25001 20L7.85001 16.8C7.63335 16.7167 7.42918 16.6167 7.23751 16.5C7.04585 16.3833 6.85835 16.2583 6.67501 16.125L3.70001 17.375L0.950012 12.625L3.52501 10.675C3.50835 10.5583 3.50001 10.4458 3.50001 10.3375V9.6625C3.50001 9.55417 3.50835 9.44167 3.52501 9.325L0.950012 7.375L3.70001 2.625L6.67501 3.875C6.85835 3.74167 7.05001 3.61667 7.25001 3.5C7.45001 3.38333 7.65001 3.28333 7.85001 3.2L8.25001 0H13.75L14.15 3.2C14.3667 3.28333 14.5708 3.38333 14.7625 3.5C14.9542 3.61667 15.1417 3.74167 15.325 3.875L18.3 2.625L21.05 7.375L18.475 9.325C18.4917 9.44167 18.5 9.55417 18.5 9.6625V10.3375C18.5 10.4458 18.4833 10.5583 18.45 10.675L21.025 12.625L18.275 17.375L15.325 16.125C15.1417 16.2583 14.95 16.3833 14.75 16.5C14.55 16.6167 14.35 16.7167 14.15 16.8L13.75 20H8.25001ZM10 18H11.975L12.325 15.35C12.8417 15.2167 13.3208 15.0208 13.7625 14.7625C14.2042 14.5042 14.6083 14.1917 14.975 13.825L17.45 14.85L18.425 13.15L16.275 11.525C16.3583 11.2917 16.4167 11.0458 16.45 10.7875C16.4833 10.5292 16.5 10.2667 16.5 10C16.5 9.73333 16.4833 9.47083 16.45 9.2125C16.4167 8.95417 16.3583 8.70833 16.275 8.475L18.425 6.85L17.45 5.15L14.975 6.2C14.6083 5.81667 14.2042 5.49583 13.7625 5.2375C13.3208 4.97917 12.8417 4.78333 12.325 4.65L12 2H10.025L9.67501 4.65C9.15835 4.78333 8.67918 4.97917 8.23751 5.2375C7.79585 5.49583 7.39168 5.80833 7.02501 6.175L4.55001 5.15L3.57501 6.85L5.72501 8.45C5.64168 8.7 5.58335 8.95 5.55001 9.2C5.51668 9.45 5.50001 9.71667 5.50001 10C5.50001 10.2667 5.51668 10.525 5.55001 10.775C5.58335 11.025 5.64168 11.275 5.72501 11.525L3.57501 13.15L4.55001 14.85L7.02501 13.8C7.39168 14.1833 7.79585 14.5042 8.23751 14.7625C8.67918 15.0208 9.15835 15.2167 9.67501 15.35L10 18ZM11.05 13.5C12.0167 13.5 12.8417 13.1583 13.525 12.475C14.2083 11.7917 14.55 10.9667 14.55 10C14.55 9.03333 14.2083 8.20833 13.525 7.525C12.8417 6.84167 12.0167 6.5 11.05 6.5C10.0667 6.5 9.23751 6.84167 8.56251 7.525C7.88751 8.20833 7.55001 9.03333 7.55001 10C7.55001 10.9667 7.88751 11.7917 8.56251 12.475C9.23751 13.1583 10.0667 13.5 11.05 13.5Z"
            fill="currentColor"
          />
        </svg>
      ),
      route: "/edit-profile",
    },
  ];
  return (
    <>
      {sidebarItems.map((item) => (
        <DesktopSidebarButton
          key={item.route}
          route={item.route}
          Icon={item.icon}
        >
          {item.text}
        </DesktopSidebarButton>
      ))}
    </>
  );
};
